import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { catchError, tap } from "rxjs/operators";
import { throwError as observableThrowError, Observable } from "rxjs";
import { StoreSettingEntity } from "../../models/entity/store/store-setting.entity";
import { BaseRestService } from "../base-rest.service";
import { SessionStorageService } from "../session-storage.service";
import { StoreCacheService } from "../cache/store-cache.service";

@Injectable({
  providedIn: 'root'
})
export class StoreSettingService extends BaseRestService {
  constructor(
    protected httpClient: HttpClient,
    protected sessionStorageService: SessionStorageService,
    private storeCacheService: StoreCacheService
  ) {
    super(httpClient, sessionStorageService);
  }

  getStoreSettings(): Observable<StoreSettingEntity[]> {
    const url = `/store-settings`;
    return this.httpGet<StoreSettingEntity[]>(url).pipe(catchError(this.errorHandler));
  }

  getStoreSettingById(id) {
    const url = `/store-settings/${id}`;
    return this.httpGet(url).pipe(catchError(this.errorHandler));
  }

  addStoreSetting(address) {
    const url = `/store-settings`;
    return this.httpPost(url, address).pipe(
      tap(() => this.storeCacheService.clearAllSettingsCache()),
      catchError(this.errorHandler)
    );
  }

  updateStoreSetting(id, address): Observable<StoreSettingEntity> {
    const url = `/store-settings/${id}`;
    return this.httpPut<StoreSettingEntity>(url, address).pipe(
      tap(() => this.storeCacheService.clearAllSettingsCache()),
      catchError(this.errorHandler)
    );
  }

  deleteStoreSetting(id) {
    const url = `/store-settings/${id}`;
    return this.httpDelete(url).pipe(
      tap(() => this.storeCacheService.clearAllSettingsCache()),
      catchError(this.errorHandler)
    );
  }

  getByStoreId(storeId: number) {
    const url = `/store-settings/by-store-id?store-id=${storeId}`;
    return this.httpGet(url).pipe(catchError(this.errorHandler));
  }

  errorHandler(error: HttpErrorResponse) {
    if (error.message)
      return observableThrowError(error);
    else return observableThrowError(error || " Server Error");
  }
}
